import { render, staticRenderFns } from "./StoreConnect.vue?vue&type=template&id=5b3e39ec&"
import script from "./StoreConnect.vue?vue&type=script&lang=js&"
export * from "./StoreConnect.vue?vue&type=script&lang=js&"
import style0 from "./StoreConnect.vue?vue&type=style&index=0&id=5b3e39ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports